<template lang="html">
  <div class="outter">
    <div class="picker" v-show="showColors">
      <chrome-picker v-model="color1"></chrome-picker>
      <chrome-picker v-model="color2"></chrome-picker>
    </div>

    <!-- <div class="header noselect" v-show="!state.id">
      {{copy.tagline}}
    </div> -->
    <!-- <div class="header noselect" v-show="state.id">
      <transition name="fade">
        <span v-show="!message||message.length<1">
          {{copy.instruction}}
        </span>
      </transition>
      <transition name="fade">
        <span v-show="message&&message.length>0">
          {{message}}
        </span>
      </transition>
    </div> -->

    <!-- <div class="logo noselect" v-show="!state.id">
      <a href="https://instagram.com/theofficialselfridges" target="_blank">
        <img :src="logo" alt="Selfridges" class="selfridges-logo" />
      </a>
    </div> -->

    <!-- <div class="footer noselect" v-show="!$route.path.indexOf('info')>=0 && !state.id">
      <a href="https://hato.co/" target="_blank">
        <img :src="hatologo" alt="HATO" class="hato-logo" />
      </a>
    </div> -->

    <!-- <div class="info noselect" v-show="!$route.path.indexOf('info')>=0 && !state.id">
       <router-link :to="{ name: 'Info', params: {} }">Info</router-link>
    </div> -->

    <div class="play noselect" :style="{background: toRgba(color1.rgba) || color1.hex}">
      <transition name="fade">
        <div class="cross noselect" @click="reset" v-show="state.id && !hideClose">
          &times;
        </div>
      </transition>
      <transition name="quick-fade">
        <div class="tools" v-if="state.id && !panning || 1">
          <div class="count">
            <div class="info">
              <span class="index">{{logIndex+1}}</span>
              <span class="base">/ {{log.length}}</span>
            </div>
            <div class="control" v-if="showControls">
              <div class="">
                <a @click="autoPlay">Play</a>
              </div>
              <div class="">
                <a @click="autoPlay(-1)">Reverse</a>
              </div>
              <div class="">
                <a @click="stop()">Stop</a>
              </div>
              <div class="">
                Duration
                <select class="" name="" v-model="duration">
                  <option :value="i" v-for="i in durationRange" :key="i">{{i}}s</option>
                </select>
              </div>
              <div class="">
                Ease
                <select class="" name="" v-model="ease">
                  <option :value="i" v-for="i in easeRange" :key="i">{{i}}</option>
                </select>
              </div>
            </div>
            <div class="">
              {{logDate}}
            </div>
          </div>
          <input
          v-model="logIndex"
          @update="updateLogIndex"
          @input="updateLogIndex"
          type="range"
          :min="-5"
          :max="log.length + 5"
          step="1">
        </div>
      </transition>
      <svg
      id="play-svg"
      :class="{'active': state.id}"
      width="1550px" height="756px" viewBox="0 0 1550 756" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <!-- Generator: Sketch 54.1 (76490) - https://sketchapp.com -->
        <g id="play" stroke="none" stroke-width="1" fill="rgba(0,0,0,0)" fill-rule="evenodd" :style="getGStyle">

          <g id="clickable-wrapper">

            <!-- <rect width="1550" height="756" stroke="green"></rect> -->
            <!-- <circle r="5" fill="#0f0" cx="775" cy="378">
            </circle> -->

            <g class="clickable" id="C-1" :transform="getGTransform('C-1')">
                <path id="C-1" :style="getLetterStyle('C-1')" :d="getData('C-1')"></path>
                <rect data-target="C-1" :x="getRectX('C-1')" :y="getRectY('C-1')" :width="getRectWidth('C-1')" :height="getRectHeight('C-1')"></rect>
            </g>
            <g class="clickable" id="R-2" :transform="getGTransform('R-1')">
                <path id="R-1" :style="getLetterStyle('R-1')" :d="getData('R-1')"></path>
                <rect data-target="R-1" :x="getRectX('R-1')" :y="getRectY('R-1')" :width="getRectWidth('R-1')" :height="getRectHeight('R-1')"></rect>
            </g>
            <g class="clickable" id="E-2" :transform="getGTransform('E-1')">
                <path id="E-1" :style="getLetterStyle('E-1')" :d="getData('E-1')"></path>
                <rect data-target="E-1" :x="getRectX('E-1')" :y="getRectY('E-1')" :width="getRectWidth('E-1')" :height="getRectHeight('E-1')"></rect>
            </g>
            <g class="clickable" id="E-3" :transform="getGTransform('E-2')">
                <path id="E-2" :style="getLetterStyle('E-2')" :d="getData('E-2')"></path>
                <rect data-target="E-2" :x="getRectX('E-2')" :y="getRectY('E-2')" :width="getRectWidth('E-2')" :height="getRectHeight('E-2')"></rect>
            </g>
            <g class="clickable" id="E-4" :transform="getGTransform('E-3')">
                <path id="E-3" :style="getLetterStyle('E-3')" :d="getData('E-3')"></path>
                <rect data-target="E-3" :x="getRectX('E-3')" :y="getRectY('E-3')" :width="getRectWidth('E-3')" :height="getRectHeight('E-3')"></rect>
            </g>
            <g class="clickable" id="A-2" :transform="getGTransform('A-1')">
                <path id="A-1" :style="getLetterStyle('A-1')" :d="getData('A-1')"></path>
                <rect data-target="A-1" :x="getRectX('A-1')" :y="getRectY('A-1')" :width="getRectWidth('A-1')" :height="getRectHeight('A-1')"></rect>
            </g>
            <g class="clickable" id="T-2" :transform="getGTransform('T-1')">
                <path id="T-1" :style="getLetterStyle('T-1')" :d="getData('T-1')"></path>
                <rect data-target="T-1" :x="getRectX('T-1')" :y="getRectY('T-1')" :width="getRectWidth('T-1')" :height="getRectHeight('T-1')"></rect>
            </g>
            <g class="clickable" id="T-4" :transform="getGTransform('T-2')">
                <path id="T-2" :style="getLetterStyle('T-2')" :d="getData('T-2')"></path>
                <rect data-target="T-2" :x="getRectX('T-2')" :y="getRectY('T-2')" :width="getRectWidth('T-2')" :height="getRectHeight('T-2')"></rect>
            </g>
            <g class="clickable" id="T-3" :transform="getGTransform('T-3')">
                <path id="T-3" :style="getLetterStyle('T-3')" :d="getData('T-3')"></path>
                <rect data-target="T-3" :x="getRectX('T-3')" :y="getRectY('T-3')" :width="getRectWidth('T-3')" :height="getRectHeight('T-3')"></rect>
            </g>
            <g class="clickable" id="I-2" :transform="getGTransform('I-1')">
                <path id="I-1" :style="getLetterStyle('I-1')" :d="getData('I-1')"></path>
                <rect data-target="I-1" :x="getRectX('I-1')" :y="getRectY('I-1')" :width="getRectWidth('I-1')" :height="getRectHeight('I-1')"></rect>
            </g>
            <g class="clickable" id="I-3" :transform="getGTransform('I-2')">
                <path id="I-2" :style="getLetterStyle('I-2')" :d="getData('I-2')"></path>
                <rect data-target="I-2" :x="getRectX('I-2')" :y="getRectY('I-2')" :width="getRectWidth('I-2')" :height="getRectHeight('I-2')"></rect>
            </g>
            <g class="clickable" id="V-2" :transform="getGTransform('V-1')">
                <path id="V-1" :style="getLetterStyle('V-1')" :d="getData('V-1')"></path>
                <rect data-target="V-1" :x="getRectX('V-1')" :y="getRectY('V-1')" :width="getRectWidth('V-1')" :height="getRectHeight('V-1')"></rect>
            </g>
            <g class="clickable" id="Y-2" :transform="getGTransform('Y-1')">
                <path id="Y-1" :style="getLetterStyle('Y-1')" :d="getData('Y-1')"></path>
                <rect data-target="Y-1" :x="getRectX('Y-1')" :y="getRectY('Y-1')" :width="getRectWidth('Y-1')" :height="getRectHeight('Y-1')"></rect>
            </g>
            <g class="clickable" id="I-4" :transform="getGTransform('I-3')">
                <path id="I-3" :style="getLetterStyle('I-3')" :d="getData('I-3')"></path>
                <rect data-target="I-3" :x="getRectX('I-3')" :y="getRectY('I-3')" :width="getRectWidth('I-3')" :height="getRectHeight('I-3')"></rect>
            </g>
            <g class="clickable" id="S-2" :transform="getGTransform('S-1')">
              <path id="S-1" :style="getLetterStyle('S-1')" :d="getData('S-1')"></path>
              <rect data-target="S-1" :x="getRectX('S-1')" :y="getRectY('S-1')" :width="getRectWidth('S-1')" :height="getRectHeight('S-1')"></rect>
            </g>
            <g class="clickable" id="N-2" :transform="getGTransform('N-1')">
              <path id="N-1" :style="getLetterStyle('N-1')" :d="getData('N-1')"></path>
              <rect data-target="N-1" :x="getRectX('N-1')" :y="getRectY('N-1')" :width="getRectWidth('N-1')" :height="getRectHeight('N-1')"></rect>
            </g>
            <g class="clickable" id="O-2" :transform="getGTransform('O-1')">
                <path id="O-1" :style="getLetterStyle('O-1')" :d="getData('O-1')"></path>
                <rect data-target="O-1" :x="getRectX('O-1')" :y="getRectY('O-1')" :width="getRectWidth('O-1')" :height="getRectHeight('O-1')"></rect>
            </g>
            <g class="clickable" id="C-3" :transform="getGTransform('C-2')">
                <path id="C-2" :style="getLetterStyle('C-2')" :d="getData('C-2')"></path>
                <rect data-target="C-2" :x="getRectX('C-2')" :y="getRectY('C-2')" :width="getRectWidth('C-2')" :height="getRectHeight('C-2')"></rect>
            </g>
            <g class="clickable" id="A-3" :transform="getGTransform('A-2')">
                <path id="A-2" :style="getLetterStyle('A-2')" :d="getData('A-2')"></path>
                <rect data-target="A-2" :x="getRectX('A-2')" :y="getRectY('A-2')" :width="getRectWidth('A-2')" :height="getRectHeight('A-2')"></rect>
            </g>
            <g class="clickable" id="N-3" :transform="getGTransform('N-2')">
                <path id="N-2" :style="getLetterStyle('N-2')" :d="getData('N-2')"></path>
                <rect data-target="N-2" :x="getRectX('N-2')" :y="getRectY('N-2')" :width="getRectWidth('N-2')" :height="getRectHeight('N-2')"></rect>
            </g>
            <g class="clickable" id="C-4" :transform="getGTransform('C-3')">
                <path id="C-3" :style="getLetterStyle('C-3')" :d="getData('C-3')"></path>
                <rect data-target="C-3" :x="getRectX('C-3')" :y="getRectY('C-3')" :width="getRectWidth('C-3')" :height="getRectHeight('C-3')"></rect>
            </g>
            <g class="clickable" id="L-2" :transform="getGTransform('L-1')">
                <path id="L-1" :style="getLetterStyle('L-1')" :d="getData('L-1')"></path>
                <rect data-target="L-1" :x="getRectX('L-1')" :y="getRectY('L-1')" :width="getRectWidth('L-1')" :height="getRectHeight('L-1')"></rect>
            </g>
            <g class="clickable" id="L-3" :transform="getGTransform('L-2')">
                <path id="L-2" :style="getLetterStyle('L-2')" :d="getData('L-2')"></path>
                <rect data-target="L-2" :x="getRectX('L-2')" :y="getRectY('L-2')" :width="getRectWidth('L-2')" :height="getRectHeight('L-2')"></rect>
            </g>
            <g class="clickable" id="D-2" :transform="getGTransform('D-1')">
                <path id="D-1" :style="getLetterStyle('D-1')" :d="getData('D-1')"></path>
                <rect data-target="D-1" :x="getRectX('D-1')" :y="getRectY('D-1')" :width="getRectWidth('D-1')" :height="getRectHeight('D-1')"></rect>
            </g>
          </g>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
import { TweenMax, Power0, Power1, Power2, Power3, Power4, Elastic, gsap } from 'gsap/all'
import { Chrome } from 'vue-color'
// import svgpath from 'svgpath'
import * as d3 from "d3";
import _ from 'lodash'
import moment from 'moment'

import records from '@/assets/json/hato-projects-together-export'
import {db, firebase} from '../../common/api'

export default {
  name: 'Gallery',

  components: {
    'chrome-picker': Chrome
  },

  beforeDestroy () {
    // let self = this
    // window.removeEventListener('resize', self.animate)
  },

  created () {
    let self = this
    firebase.auth().onAuthStateChanged(function(user) {
      if (user) {
        // User is signed in.
        // var isAnonymous = user.isAnonymous;
        var uid = user.uid;
        self.uid = uid
        // console.log(user, uid)
        // ...
      } else {
        // User is signed out.
        // ...
        // console.log('signed out')
      }
      // ...
    });
    firebase.auth().signInAnonymously().catch(function() {
      // Handle Errors here.
      // var errorCode = error.code;
      // var errorMessage = error.message;
      // ...
      // console.log(error)
      // debugger
    });
  },

  mounted () {
    // let self = this
    // window.addEventListener('resize', self.animate)
    this.getDataFromFirebase()
    this.animate()
    this.init_d3()
    this.bind_firebase()
    this.d3_state.reset()
  },

  data () {
    return {
      logo: require('@/assets/selfridges-white.svg'),
      hatologo: require('@/assets/hato-white.svg'),
      uid: null,
      currentStyle: 1,
      color1: {
        hex: '#000'
      },
      color2: {
        hex: '#ff7300'
      },
      copy: {
        tagline: '',
        instruction: ''
      },
      controls: {
        scaleXmin: 0.5,
        scaleXmax: 1.2,
        scaleX: 1,
        scaleYmin: 0.25,
        scaleYmax: 1.5,
        scaleY: 1,
        transformXmin: 1,
        transformXmax: 1,
        transformX: 1,
        transformYmin: 1,
        transformYmax: 1,
        translateY: 1,
        skewXmin: -20,
        skewXmax: 20,
        skewX: 0,
        strokeType: 0,
        strokeTypeMin: 0,
        strokeTypeMax: 2,
        strokeWidth: 20,
        strokeWidthMin: 5,
        strokeWidthMax: 40,
      },
      state: {
        type: undefined,
        id: undefined
      },
      lastState: {
        type: undefined,
        id: undefined
      },
      typeState: {
        d_new:'',
        d_source:'',
        scaleX:'',
        scaleY:'',
        skewX:'',
        stroke_linecap:'',
        stroke_linejoin:'',
        stroke_dasharray:'',
        stroke_width:'',
        strokeType:'',
      },
      defaultTypeState: {
        d_new:'',
        d_source:'',
        scaleX:'',
        scaleY:'',
        skewX:'',
        key: undefined,
        stroke_linecap:'',
        stroke_linejoin:'',
        stroke_dasharray:'',
        stroke_width:'',
        strokeType:'',
      },
      zoom: false,
      d3_state: {},
      message: '',
      hideClose: false,
      panning: false,
      logIndex: 0,
      logDate: null,
      type: null,
      typeOriginal: null,
      typeStarter: [],
      liveRecords: null,
      duration: 3,
      ease: 'ease3',
      timeline: null
    }
  },

  // firebase: {
  //   type: db.ref(`private/together/type`),
  // },

  computed: {

    showControls () {
      return this.$route.hash && this.$route.hash.indexOf('controls') >= 0
    },

    records () {
      return this.liveRecords || records.log
    },

    log () {
      return [...this.typeStarter, ..._.orderBy(_.toArray(this.records), ['createdAt'], ['asc'])]
    },

    showColors () {
      if (window.location.hash.indexOf('colour')>0) {
        return true
      }
      return false
    },

    getGStyle () {
      return {
        'transform': 'scale(1) translate(0,0)'
      }
    },

    durationRange () {
      return _.range(1, 30)
    },

    easeRange () {
      return ['linear',
              'ease1',
              'ease2',
              'ease3',
              'ease4']
    }
  },

  methods: {

    getDataFromFirebase () {
      db.ref('private/together/type').once('value', snapshot => {
        this.type = snapshot.val()
        this.typeOriginal = snapshot.val()
        this.createTypeStarter()
        this.logIndex = 9999
        this.updateLogIndex()
        // do something with document
      })

      db.ref('private/together/log').once('value', snapshot => {
        this.liveRecords = snapshot.val()
      })
    },

    createTypeStarter () {
      let styles = [
        {
          stroke_linecap:'round',
          stroke_linejoin: 'round',
          stroke_dasharray: `0 15`
        },
        {
          stroke_linecap:'butt',
          stroke_linejoin: 'miter',
          stroke_dasharray: `2 2`
        },
        {
          stroke_linecap:'square',
          stroke_linejoin: 'square',
          stroke_dasharray: `0 17`
        }
      ]

      this.typeStarter = _.map(_.cloneDeep(this.typeOriginal), (t) => {
        t.d_new = _.clone(t.d_source)
        t.scaleX = 1
        t.scaleY = 1
        t.skewX = 0
        t.strokeType = 0
        t.stroke_dasharray = styles[2].stroke_dasharray
        t.stroke_linecap = styles[2].stroke_linecap
        t.stroke_linejoin = styles[2].stroke_linejoin
        t.stroke_width = 18
        return {
          typeKey: _.clone(t.id),
          type: t,
          createdAt: null,
        }
      })
    },

    forceResetToStarter () {
      for (var i = 0; i < this.typeStarter.length; i++) {
        this.updateTypeByKey(this.typeStarter[i]['typeKey'], this.typeStarter[i]['type'])
      }
    },

    autoPlay (dir=1) {
      this.stop()
      let dur = this.duration || 1
      let min = this.logIndex
      let max = this.log.length + 5
      let self = this
      let replay = {
        state: min,
      }
      let from = min
      let to = max
      if (dir < 1) {
        from = this.logIndex
        to = -5
      }
      replay.state = from

      let ease = {
        'linear': Power0.easeNone,
        'ease1' : Power1.easeInOut,
        'ease2' : Power2.easeInOut,
        'ease3' : Power3.easeInOut,
        'ease4' : Power4.easeInOut
      }

      this.timeline = gsap.to(replay, dur, {
        'state': to,
        repeat: 0,
        ease: ease[this.ease],
        onUpdate: () => {
          let state = _.round(replay.state)
          self.logIndex = state
          // console.log(self.logIndex)
          self.updateLogIndex()
        }
      })
    },

    stop () {
      // TweenMax.killAll()
      // gsap.globalTimeline.clear()
      if (this.timeline && this.timeline.pause) {
        this.timeline.pause()
      }
    },

    updateLogIndex () {
      // console.log(this.log[this.logIndex])
      this.logIndex = _.round(Math.max(0, Math.min(this.logIndex, this.log.length - 1)))
      let index = this.logIndex

      if (index == 0) {
        this.forceResetToStarter()
        return
      }

      let currentLog = this.log[index]
      let typeKey = currentLog['typeKey']
      let type = currentLog['type']
      let time = currentLog['createdAt']
      let formatedTime = time ? moment(time).format('D/M hh:mm:ss') : null
      this.logDate = formatedTime

      this.updateTypeByKey(typeKey, type)
    },

    updateTypeByKey (typeKey, type) {
      this.$set(this.type[typeKey], 'd_new', type['d_new'])
      this.$set(this.type[typeKey], 'scaleX', type['scaleX'])
      this.$set(this.type[typeKey], 'scaleY', type['scaleY'])
      this.$set(this.type[typeKey], 'skewX', type['skewX'])
      this.$set(this.type[typeKey], 'strokeType', type['strokeType'])
      this.$set(this.type[typeKey], 'stroke_dasharray', type['stroke_dasharray'])
      this.$set(this.type[typeKey], 'stroke_linecap', type['stroke_linecap'])
      this.$set(this.type[typeKey], 'stroke_linejoin', type['stroke_linejoin'])
      this.$set(this.type[typeKey], 'stroke_width', type['stroke_width'])
    },

    bind_firebase () {
      this.$rtdbBind('color1', db.ref(`private/together/config`).child('background-colour'))
      this.$rtdbBind('color2', db.ref(`private/together/config`).child('text-colour'))
      this.$rtdbBind('copy', db.ref(`private/together/config`).child('copy'))
    },

    resetTypeState () {
      this.typeState = Object.assign({}, this.typeState, this.defaultTypeState)
    },

    updateInputModelById (key) {
      let type = this.type[key]

      this.$set(this.controls, 'scaleX', type.scaleX)
      this.$set(this.controls, 'scaleY', type.scaleY)
      this.$set(this.controls, 'skewX', -type.skewX)
      this.$set(this.controls, 'strokeType', type.strokeType)
      this.$set(this.controls, 'strokeWidth', type.stroke_width)
    },

    init_d3 () {
      let self = this
      // debugger
      let zoom = d3.zoom()
        .scaleExtent([1, 8])
        .on("zoom", zoomed);

      let svg = d3.select('#play-svg')
          svg.on("click", reset);

      let g = d3.select('#clickable-wrapper')

      svg.selectAll("g.clickable rect").on("click", clicked)

      svg.call(zoom)
      .on("wheel.zoom", null)
      .on("click.zoom", null)
      .on("dblclick.zoom", null)
      .on("mousedown.zoom", null)
      .on("touchstart.zoom", null)
      .on("touchmove.zoom", null)
      .on("touchend.zoom", null);

      function reset() {
        let width = 1550
        let height = 756
        let x = width/2
        let y = height/2
        let scale = 1.2;
        if (window.innerWidth < 500) { scale = 1.5 }
        if (window.innerWidth / window.innerHeight > 2) { scale = 1.2 }

        svg.transition().duration(750).call(
          zoom.transform,
          // d3.zoomIdentity,
          d3.zoomIdentity.translate(width / 2, height / 2).scale(scale).translate(-x, -y),
          d3.zoomTransform(svg.node()).invert([width / 2, height / 2])
        )
        .on("start", startCallback)
        .on("end", endCallback);

        // self.pushLogToDatabase()
        // set state
        self.state.id = undefined
        self.state.type = undefined
        self.resetTypeState()
      }

      function clicked(typeId = undefined) {
        // debugger
        // const bbox = this.parentElement.getBBox()

        // this -> rect
        // this.parentElement -> g

        // const bbox = this.parentElement.getBoundingClientRect()
        const id = typeId || this.getAttribute('data-target')
        const type = self.type[id]

        if (!type || !type.x) {
          // console.error('no type found')
        }

        // set state
        self.state.id = id
        self.state.type = type
        // self.updateInputModelById(id)
        if (window.gtag) {
          window.gtag('config', 'UA-84126832-5', {'page_path': `/${id}`});
        }
        // self.pushLogToDatabase()

        let x = type.x + type.w/2
        let y = type.y + type.h/2

        if (window.innerWidth < 500) {
          y = y + 20
        }
        // let width = window.innerWidth
        // let height = window.innerHeight
        let width = 1550
        let height = 756
        let ratio = window.innerWidth/window.innerHeight
        let scale = 1/ratio * 4
        if (ratio > 1) {
          scale = 1/ratio * 6
        }
        // console.log((2-ratio) * -70, (ratio-2) * -20)
        // console.log(scale)
        // debugger
        if (d3.event) {
          d3.event.stopPropagation();
          svg.transition().duration(750).call(
            zoom.transform,
            d3.zoomIdentity.translate(width / 2, height / 2).scale(scale).translate(-x, -y),
            // d3.zoomIdentity.translate(width / 2, height / 2).scale(4).translate(-1550/2, -756/2),
            d3.mouse(svg.node())
          )
          .on("start", startCallback)
          .on("end", endCallback);
        } else {
          svg.transition().duration(750).call(
            zoom.transform,
            d3.zoomIdentity.translate(width / 2, height / 2).scale(scale).translate(-x, -y),
            d3.zoomTransform(svg.node()).invert([width / 2, height / 2])
            // ,
            // d3.zoomIdentity.translate(width / 2, height / 2).scale(4).translate(-1550/2, -756/2),
            // d3.mouse(svg.node())
          )
          .on("start", startCallback)
          .on("end", endCallback);
        }

      }

      function zoomed() {
        g.attr("transform", d3.event.transform);
      }

      function startCallback() {
        self.panning = true
      }

      function endCallback() {
        self.panning = false
      }
      self.d3_state.reset = reset
      self.d3_state.clicked = clicked
      self.d3_state.zoomed = zoomed
      self.d3_state.svg = svg
      self.d3_state.zoom = zoom
      self.d3_state.g = g
    },

    getRandomId () {
      // let lastId = _.clone(this.state.id)
      let randId = _.sample(this.type).id
      while (randId === this.state.id) {
        randId = _.sample(this.type).id
      }
      return randId
    },

    next () {
      let randId = this.getRandomId()
      // console.log(randId)
      // this.pushLogToDatabase()
      if (this.d3_state.clicked) {
        this.d3_state.clicked(randId)
      }
    },

    reset () {
      if (this.d3_state.reset) {
        this.d3_state.reset()
      }
      return
    },

    toRgba (rgba) {
      if (!rgba) { return false }
      return `rgba(${rgba.r}, ${rgba.g}, ${rgba.b}, ${rgba.a})`
    },

    animate () {
      // console.log('animate')
      // return;
      TweenMax.fromTo('path', 60, {
        'stroke-dashoffset': 0
      }, {
        'stroke-dashoffset': 1200,
        repeat: -1,
        ease: Power0.easeNone
        // ease: Power4.easeInOut
      })

      // this.yo()
      // this.yo()
      // this.yo()
    },

    toggleZoom () {
      this.zoom = !this.zoom
    },

    selectLetter () {
      return false
      // console.log(target)
      // if (!this.zoom) {
      //   this.zoom = true
      // } else {
      // this.shuffle_style(target)
      // this.path_bounce (target)
      // }
    },

    getData (id) {
      if (!this.type) return;
      return this.type[id].d_new
    },

    getRectX (id) {
      if (!this.type) return;
      return -this.type[id].w/3
    },

    getRectY (id) {
      if (!this.type) return;
      return -this.type[id].h/3
    },

    getRectWidth (id) {
      if (!this.type) return;
      return this.type[id].w*1.5
    },

    getRectHeight (id) {
      if (!this.type) return;
      return this.type[id].h*1.5
    },

    getGTransform (id) {
      if (!this.type) return;
      return `translate(${this.type[id].x}, ${this.type[id].y})`
    },

    getLetterStyle (id) {
      if (!this.type) return;
      let type = this.type[id]
      if (!this.zoom) {
        return {
          'opacity': this.state.id ? (id===this.state.id ? 1 : 0.3 ) : 1,
          'stroke': this.toRgba(this.color2.rgba) || this.color2.hex,
          'stroke-width': type.stroke_width,
          'stroke-dashoffset': type.stroke_dashoffset,
          'stroke-dasharray': type.stroke_dasharray,
          'stroke-linecap': type.stroke_linecap,
          'stroke-linejoin': type.stroke_linejoin
        }
      }
    },

    yo () {
      // console.log('yo')
      this.shuffle_style()
      this.path_bounce()
    },

    path_bounce (id) {
      let selector = id ? `#play path#${id}` : '#play path'
      TweenMax.fromTo(selector, 2, {
        'stroke-width': 5
      }, {
        'stroke-width': 10 + Math.random() * 5,
        ease: Elastic.easeOut.config(1.5, 0.2)
      })
    },

    shuffle_style (id) {
      let stroke = Math.random() * 10 + 10
      let gap = 40 - stroke
      let selector = id ? `#play path#${id}` : '#play path'
      let style0 = {
        'stroke-width': stroke,
        'stroke-dashoffset': 0,
        // 'stroke-dasharray': '10 80',
        'stroke-dasharray': `${gap / 5} ${stroke * 1}`,
        'stroke-linecap': 'square',
        'stroke-linejoin': 'square'
      }
      let style1 = {
        'stroke-width': stroke,
        'stroke-dashoffset': 0,
        // 'stroke-dasharray': '40 50',
        'stroke-dasharray': `${0} ${gap * .6}`,
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round'
      }
      let style2 = {
        'stroke-width': stroke,
        'stroke-dashoffset': 0,
        // 'stroke-dasharray': '10 20 10 20 10 20',
        'stroke-dasharray': `${stroke / 10} ${gap / 3} ${stroke / 10} ${gap / 3} ${stroke / 10} ${gap / 3}`,
        'stroke-linecap': 'butt',
        'stroke-linejoin': 'miter'
      }

      switch (this.currentStyle) {
        case 0:
          TweenMax.set(selector, style0)
          this.currentStyle = 1
          break
        case 1:
          TweenMax.set(selector, style1)
          this.currentStyle = 2
          break
        case 2:
          TweenMax.set(selector, style2)
          this.currentStyle = 0
          break
      }
    }
  }
}
</script>

<style scoped lang="scss">
.header {
  position: absolute;
  top: 0;
  left: 0;
  right: 3rem;
  padding: 1rem;
  z-index: 999;
  font-weight: 600;
}
.logo {
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 1rem;
  z-index: 999;
}
.info {
  // position: absolute;
  // top: 0;
  // right: 0;
  display: flex;
  padding: 1rem;
  z-index: 999;
  a {
    display: block;
    margin-left: 1em;
    color: white;
  }
}
.footer {
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 1rem;
  z-index: 999;
}
.outter {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.picker {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 9999999;
}
.selfridges-logo {
  display: block;
  width: 150px;
}
.hato-logo {
  display: block;
  width: 80px;
}
.cross {
  position: absolute;
  right: 0rem;
  top: .5rem;
  font-size: 3rem;
  height: 1em;
  width: 1em;
  line-height: 1;
  color: white;
  cursor: pointer;
  font-weight: 100;
  z-index: 99999;
}
.play {
  width: 100%;
  height: 100%;
}
#play {
  cursor: pointer;
  pointer-events: initial;
  transform-origin: 50% 50%;
  transform: scale(1.3);
}
svg {
  width: 100%;
  height: 100%;
}
path {
  pointer-events: none;
  /* stroke: black; */
  transform-origin: center bottom;
  transition: .1s ease all;
}
g.clickable {
  fill: rgba(0,0,0,0);
  cursor: pointer;
  pointer-events: initial;
}

rect {
  // stroke: red;
  transition: .3s ease opacity;
  cursor: pointer;
  pointer-events: initial;
}

rect {
  cursor: zoom-in;
}
svg.active {
  cursor: zoom-out;
  rect {
    cursor: pointer;
  }
}

#play {
  /* transform: translate(0px, -100px); */
}


$upper: #000;
$track: #000;

.tools {
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  padding: 2rem;
  z-index: 99;
  margin: auto;
  width: 100%;
  // max-width: 100rem;
  // max-width: calc(100% - 30rem);
  max-width: calc(100%);

  .count {
    position: absolute;
    bottom: 100%;
    left: 2rem;
    right: 2rem;
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    line-height: 1;

    .control {
      display: flex;
      color: white;
      a {
        color: white;
      }
      > div {
        margin-left: 1em;
      }
    }

    select {
      // -webkit-appearance: text;
      // width: 4em;
      // line-height: 1;
      // display: block;
      // padding: 0.2em;
    }

    a, input, select {
      display: inline-block;
      line-height: 1;
      padding: 0;
      margin: 0 0 0;
    }
    .index {
      font-size: 1rem;
    }
    .base {
      font-size: 1rem;
    }
  }

  a {
    // display: block;
    // width: 100%;
    // line-height: 1;
    // padding: .35rem;
    // margin-top: .3rem;
    // text-align: center;
    // border-radius: 2rem;
    // cursor: pointer;

    @media screen and (max-width: 1024px) {

    }
  }

  input {
    margin-left: 0;
    margin-right: 0;
  }

  input[type=range] {
    -webkit-appearance: none; /* Hides the slider so that custom slider can be made */
    width: 100%; /* Specific width is required for Firefox. */
    background: transparent; /* Otherwise white in Chrome */
    height: 2rem;
    cursor: ew-resize;
    cursor: pointer;
    margin-bottom: .1rem;
    margin-top: .1rem;
    display: block;
  }

  input[type=range]::-webkit-slider-thumb {
    -webkit-appearance: none;
  }

  input[type=range]:focus {
    outline: none; /* Removes the blue border. You should probably do some kind of focus styling for accessibility reasons though. */
  }

  input[type=range]::-ms-track {
    width: 100%;
    cursor: pointer;

    /* Hides the slider so custom styles can be added */
    background: transparent;
    border-color: transparent;
    color: transparent;
  }

  input[type=range]::-webkit-slider-thumb {
    -webkit-appearance: none;
    // border: 1px solid #000000;
    font-size: 1.0rem;
    height: 1.5em;
    width: 1.5em;
    border-radius: 1.5em;
    border: 3px solid rgba(0,0,0,1);
    outline: .75em solid rgba(0,0,0,0);
    background: #ffffff;
    cursor: pointer;
    cursor: ew-resize;
    margin-top: -.3em; /* You need to specify a margin in Chrome, but in Firefox and IE it is automatic */
    // box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d; /* Add cool effects to your sliders! */
    // box-shadow: 0px 1px 3px #000000;
  }

  /* All the same stuff for Firefox */
  input[type=range]::-moz-range-thumb {
    // box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    // box-shadow: 0px 1px 3px #000000;
    // border: 1px solid #000000;
    font-size: 1.3rem;
    height: 1.5em;
    width: 1.5em;
    border-radius: 1.5em;
    border: 5px solid rgba(0,0,0,0);
    background: #ffffff;
    cursor: pointer;
    cursor: ew-resize;
  }

  /* All the same stuff for IE */
  input[type=range]::-ms-thumb {
    // box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    // border: 1px solid #000000;
    font-size: 1.3rem;
    height: 1.5em;
    width: 1.5em;
    border-radius: 1.5em;
    border: 5px solid rgba(0,0,0,0);
    background: #ffffff;
    // box-shadow: 0px 1px 3px #000000;
    cursor: pointer;
    cursor: ew-resize;
  }

  input[type=range]::-webkit-slider-runnable-track {
    width: 100%;
    height: 1.6rem;
    cursor: pointer;
    // cursor: ew-resize;
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    background: $track;
    border-radius: 2rem;
    border: 5px solid $track;
  }

  input[type=range]:focus::-webkit-slider-runnable-track {
    background: $upper;
    border-color: $upper;
  }

  input[type=range]::-moz-range-track {
    width: 100%;
    height: 1.6rem;
    cursor: pointer;
    cursor: ew-resize;
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    background: $track;
    border-radius: 2rem;
    border: 5px solid $track;
  }

  input[type=range]::-ms-track {
    width: 100%;
    height: 1.6rem;
    cursor: pointer;
    cursor: ew-resize;
    background: transparent;
    border-color: transparent;
    border-width: 16px 0;
    color: transparent;
  }
  input[type=range]::-ms-fill-lower {
    background: $track;
    border: 5px solid $track;
    border-radius: 2.6px;
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
  }
  input[type=range]:focus::-ms-fill-lower {
    background: $track;
  }
  input[type=range]::-ms-fill-upper {
    background: $track;
    border: 5px solid $track;
    border-radius: 2.6px;
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
  }
  input[type=range]:focus::-ms-fill-upper {
    background: $upper;
    border-color: $upper;
  }
}
.message {
  position: absolute;
  top: -1rem;
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
  padding: 1rem;
}




@media screen and (max-width: 1024px) {
  // .play {
  //   height: 100vh;
  // }
}
</style>
